<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"Assign New Course" | translate}}</h5>
        <div class="edit-icons" mat-dialog-close>
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content ">
        <div class="form-c mt-2 assign">

            <div class="form mt-4 position-relative" *ngFor="let aItem of assignArr;let i=index">
                <div *ngIf="i!=0" (click)="onRemove(i)" class="dele-icon">
                    <img src="assets/images/icons/delete_item.svg" class="img-fluid" alt="">
                </div>
              
                <div class="row mt-4">                  
                    <div class="col-12 col-lg-6  pe-lg-3 ">
                        <mat-radio-group [(ngModel)]="assignArr[i].isPublish">
                            <mat-radio-button class="example-margin ms-0 i-title-b" value="1">Publish now</mat-radio-button>
                            <mat-radio-button class="example-margin ms-0 i-title-b" value="0">Schedule Publish</mat-radio-button>
                        </mat-radio-group>
                        <div class="row  mt-3" *ngIf="assignArr[i].isPublish==0">
                            <div class="col-12 col-lg-7">
                                <div class="input-div d-flex align-items-center">
                                    <input class="" [matDatepicker]="publishDate" [min]="minDate" placeholder="Select Date" readonly
                                        [(ngModel)]="assignArr[i].training_date" />
                                    <mat-datepicker-toggle matIconSuffix [for]="publishDate"></mat-datepicker-toggle>
                                    <mat-datepicker #publishDate></mat-datepicker>
                                </div>
                            </div>
                            <div class="col-12 col-lg-5  mt-2 mt-lg-0">
                                <div class="input-div d-flex align-items-center ps-3">
                                    <img src="assets/images/icons/timer_grey.svg" height="16px" alt="">
                                    <input class="" [ngxTimepicker]="fullTime" [format]="24" readonly class="time-p"
                                        [(ngModel)]="assignArr[i].training_time" />
                                    <ngx-material-timepicker #fullTime></ngx-material-timepicker>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="i-title-b mt-4">Courses List</div>
                            <mat-select class="form-control sources me-3 " placeholder="Select Courses"
                                (selectionChange)="onCourseList(i,$event)" [(ngModel)]="assignArr[i].course_item">
                                <mat-option [value]="item" *ngFor="let item of courseArr">{{item.tit}}
                                    ({{item.p_n}})</mat-option>
                            </mat-select>
                        
                            <div class="i-title-b mt-4">
                                <mat-checkbox name="schedule" [(ngModel)]="assignArr[i].isSendReminder" class="check"></mat-checkbox>
                                Send a Reminder if user didn't view by
                            </div>
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="input-div d-flex align-items-center">
                                        <input class="" [matDatepicker]="remindDate" placeholder="Select Date" readonly
                                            [(ngModel)]="assignArr[i].reminder_date" />
                                        <mat-datepicker-toggle matIconSuffix [for]="remindDate"></mat-datepicker-toggle>
                                        <mat-datepicker #remindDate></mat-datepicker>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5  mt-2 mt-lg-0">
                                    <div class="input-div d-flex align-items-center ps-3">
                                        <img src="assets/images/icons/timer_grey.svg" height="16px" alt="">
                                        <input class="" [ngxTimepicker]="remindTime" [format]="24" readonly class="time-p"
                                            [(ngModel)]="assignArr[i].reminder_time" />
                                        <ngx-material-timepicker #remindTime></ngx-material-timepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="i-title-b mt-4">Training Date Time</div>
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="input-div d-flex align-items-center ">
                                        <input class="" [matDatepicker]="trainingDate" placeholder="Select Date" readonly
                                            [(ngModel)]="assignArr[i].training_date" />
                                        <mat-datepicker-toggle matIconSuffix [for]="trainingDate"></mat-datepicker-toggle>
                                        <mat-datepicker #trainingDate></mat-datepicker>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5  mt-2 mt-lg-0">
                                    <div class="input-div d-flex align-items-center ps-3">
                                        <img src="assets/images/icons/timer_grey.svg" height="16px" alt="">
                                        <input class="" [ngxTimepicker]="trainingTime" [format]="24" readonly class="time-p"
                                            [(ngModel)]="assignArr[i].training_time" />
                                        <ngx-material-timepicker #trainingTime></ngx-material-timepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="i-title-b mt-3">
                                <mat-checkbox class="ps-0" name="schedule" class="check"
                                    [(ngModel)]="assignArr[i].isNotifyEmployee"></mat-checkbox>
                                Notify Employees via Push Notification
                            </div>
                            <div class="input-div">
                                <input type="text" [(ngModel)]="assignArr[i].notification_msg">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6  ps-lg-4">
                        <div>
                            <div class="i-title-b ">Managers List</div>
                        
                            <mat-select class="form-control sources me-3 " placeholder="Select Manager"
                                [(ngModel)]="assignArr[i].manager_id">
                                <mat-option [value]="item.manager_id" *ngFor="let item of managerArr"
                                    [value]="item.manager_id"> {{item.first_name}}{{item.last_name}}
                                </mat-option>
                            </mat-select>
                            <div class="i-title-b mt-4">
                                <mat-checkbox name="schedule" [(ngModel)]="assignArr[i].isScheduleRemoval" class="check"></mat-checkbox>
                                Schedule Removal from the App
                            </div>
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="input-div d-flex align-items-center ">
                                        <input class="" [matDatepicker]="removeDate" placeholder="Select Date" readonly
                                            [(ngModel)]="assignArr[i].remove_date" />
                                        <mat-datepicker-toggle matIconSuffix [for]="removeDate"></mat-datepicker-toggle>
                                        <mat-datepicker #removeDate></mat-datepicker>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5  mt-2 mt-lg-0">
                                    <div class="input-div d-flex align-items-center ps-3">
                                        <img src="assets/images/icons/timer_grey.svg" height="16px" alt="">
                                        <input class="" [ngxTimepicker]="removeTime" [format]="24" readonly class="time-p"
                                            [(ngModel)]="assignArr[i].remove_time" />
                                        <ngx-material-timepicker #removeTime (closed)="timePickerStates[0] = false"></ngx-material-timepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="i-title-b mt-4">Deadline Date Time</div>
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="input-div d-flex align-items-center ">
                                        <input class="" [matDatepicker]="deadlineDate" placeholder="Select Date" readonly
                                            [(ngModel)]="assignArr[i].deadline_date" />
                                        <mat-datepicker-toggle matIconSuffix [for]="deadlineDate"></mat-datepicker-toggle>
                                        <mat-datepicker #deadlineDate></mat-datepicker>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5 mt-2 mt-lg-0">
                                    <div class="input-div d-flex align-items-center ps-3 ">
                                        <img src="assets/images/icons/timer_grey.svg" height="16px" alt="">
                                        <input class="" [ngxTimepicker]="deadlineTime" [format]="24" readonly class="time-p"
                                            [(ngModel)]="assignArr[i].deadline_time"  />
                                        <ngx-material-timepicker #deadlineTime ></ngx-material-timepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <div class="i-box cursor-pointer mt-3 ">
            <span (click)="onAdd()" class="pe-3"><i class="fas fa-plus"></i> Add Course</span>
          </div>
    </div>

    <div class="mt-2"><mat-error>{{errorMsg}}</mat-error></div>
    <div class="btn-container d-flex   justify-content-center onnoard-company-modal">
        <button type="button" class="ms-lg-auto btn btn-outline-primary me-2 mt-3 " mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" class="primary-btn d-box  mb-2 mb-md-0 mt-3 " (click)="onSubmit()" type="submit">Assign Course</button>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>